<template lang="html">
  <div class="container">

    <div class="header">
      <p class="select">
        阿米巴详情
        <i class="iconfont icon-fanhui" @click="back"></i>
      </p>
    </div>
    <div class="listtxt">
      <h2>{{data.title}}</h2>
      <ul>
        <li>
          <p>所属项目<span>{{data.project_name}}</span></p>
        </li>


        <li>
          <p>数量<span>{{data.num}}</span></p>
        </li>


        <li>
          <p>创建时间<span>{{data.created_at.slice(0,10)}}</span></p>
        </li>



        <li>
          <p>阿米巴报价<span>¥{{data.price}}</span></p>
        </li>



        <li>
          <p>产值<span>{{data.value}}</span></p>
        </li>

        <li style="border:0;height: 50px;line-height: 50px;">
          <p class="">本周工作内容</p>
        </li>

        <li style="border:0">
          <p class="more">
              {{data.context == null ? '暂无' : data.context}}
          </p>
        </li>

        <!-- <li style="border:0">
          <p class="more">
            2
          </p>
        </li> -->

        <li style="border:0;height: 50px;line-height: 50px;">
          <p class="">
            工作明细
            <br>
          </p>
        </li>
        <li style="border:0">
          <p class="more">
            {{data.description}}
          </p>
        </li>


        <li style="margin-top: 35px;">
          <p>
            工作占总内容百分比
            <span>{{data.percentage}}%</span>
          </p>
        </li>


        <li>
          <p>
            累计完成度
            <span>{{data.heap_complete}}%</span>
          </p>
        </li>

        <li>
          <p>
            本周完成度
            <span>{{data.complete}}%</span>
          </p>
        </li>


        <li>
          <p>
            渲染费
            <span>¥{{data.render_cost == null ? '0' : data.render_cost}}</span>
          </p>
        </li>

      </ul>
    </div>



  </div>
</template>

<script>
export default {
  props:[
    'data',
  ],
  data () {
    return {
    }
  },
  methods: {
    back () {
      this.$emit('on-return')
    },
  },
  created () {

  },
}
</script>

<style lang="css" scoped>
  .container {
    height: 100%;
    width: 100%;
    background-color: #fafafa;
    font-family: PingFangSC-Regular;
  }
  .header{
    width: 100%;
    background: #f5f5f5;
  }
  .select{
    width: 100%;
    color: #333333;
    height: 1.1875rem;
    background: #fff;
    font-size: 0.40625rem;
    line-height: 1.1875rem;
    padding-left: 0.34375rem;
    position: relative;
    text-align: center;
  }
  .iconfont{
    position: absolute;
    left: 0.34375rem;
    font-size: 0.4375rem;
    font-weight: bolder;
    line-height: 1.1875rem;
    color: #86898E;
    z-index: 2;
  }
  .listtxt{
    color: #333333;
    width: 100%;
    background: #fff;
    height: 100%;
  }
  .listtxt h2{
    color: #333333;
    width: 100%;
    text-align: center;
    font-size: 0.4375rem;
    margin-bottom: 1.125rem;
    padding-top: 0.4375rem;
  }
  .listtxt ul{
    width: 100%;
  }
  .listtxt ul li{
    height: 0.9375rem;
    line-height: 0.9375rem;
    border-bottom: 1px solid #ddd;
    position: relative;
  }
  .listtxt ul li p{
    color: #333333;
    width: 100%;
    text-align: left;
    font-size: 0.4375rem;
    padding-left: 0.8125rem;
  }
  .listtxt ul li span{
    color: #333333;

    font-size: 0.4375rem;
    position: absolute;
    right: 1.15625rem;
  }

  .more{
    width: 85% !important;
    margin: auto!important;
    padding-left: 0!important;
    border-bottom: 1px solid #ddd!important;
  }

</style>



// WEBPACK FOOTER //
// src/components/AmbDetail.vue